import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

export default function LoadingSpinner({
  size = 'md',
  message,
}: LoadingSpinnerProps) {
  // sm is used inline inside buttons/compact UI — the book animation would be
  // illegible at 24px, so keep the lightweight CSS ring for that case.
  if (size === 'sm') {
    return (
      <div
        className="inline-flex items-center justify-center"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div
          className="w-6 h-6 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"
          aria-hidden="true"
        />
        {message && <span className="sr-only">{message}</span>}
      </div>
    );
  }

  const circleSize = size === 'lg' ? 'w-32 h-32' : 'w-24 h-24';
  const animationSize = size === 'lg' ? 112 : 80;

  return (
    <div
      className="flex flex-col items-center justify-center p-8"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div
        className={`${circleSize} rounded-full bg-primary-50 ring-1 ring-primary-100 flex items-center justify-center overflow-hidden`}
        aria-hidden="true"
      >
        <DotLottieReact
          src="/animations/book-loader.lottie"
          loop
          autoplay
          style={{ width: animationSize, height: animationSize }}
        />
      </div>
      {message && (
        <p className="mt-4 text-sm text-neutral-600">{message}</p>
      )}
    </div>
  );
}
